import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api, money, pct } from "@/lib/api";
import InvestPanel from "@/components/invest/InvestPanel";
import MobileInvestBar from "@/components/invest/MobileInvestBar";

export default function StockDetail() {
  const { id } = useParams();
  const [stock, setStock] = useState(null);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    api.get(`/stocks/${id}`).then(({ data }) => setStock(data)).catch(() => setError(true));
  }, [id]);
  useEffect(load, [load]);

  if (error) return <div className="container-x py-24 text-slate-400" data-testid="stock-not-found">This stock is no longer listed. <Link to="/markets" className="text-emerald-400">Back to markets</Link></div>;
  if (!stock) return <div className="flex justify-center py-32"><Loader2 className="h-6 w-6 animate-spin text-emerald-500" /></div>;
  const up = stock.change_pct >= 0;

  return (
    <div className="container-x py-14" data-testid="stock-detail-page">
      <Link to="/markets" className="-my-2 inline-flex items-center gap-2 py-2 text-sm text-slate-400 hover:text-white" data-testid="stock-back-link"><ArrowLeft className="h-4 w-4" /> All stocks</Link>
      <div className="mt-10 grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <p className="eyebrow">{stock.sector || "Equity"}</p>
          <h1 className="mt-3 font-display text-4xl font-semibold tracking-tighter text-white sm:text-5xl" data-testid="stock-detail-name">{stock.name}</h1>
          <div className="mt-8 flex flex-wrap items-end gap-6">
            <span className="font-mono text-5xl tracking-tighter text-white" data-testid="stock-detail-price">{money(stock.price)}</span>
            <span className={`pb-2 font-mono text-lg ${up ? "text-emerald-400" : "text-red-400"}`}>{pct(stock.change_pct)} today</span>
          </div>
          <div className="panel mt-10 p-6 sm:p-8">
            <p className="eyebrow mb-4">About {stock.ticker}</p>
            <p className="whitespace-pre-line leading-relaxed text-slate-300" data-testid="stock-detail-description">{stock.description || "No description yet."}</p>
          </div>
        </div>
        <div id="invest-panel" className="scroll-mt-24 lg:col-span-5">
          <InvestPanel assetType="stock" asset={stock} price={stock.price} label={stock.ticker} onDone={load} />
        </div>
      </div>
      <MobileInvestBar label={`${stock.ticker} · ${stock.name}`} price={`${money(stock.price)} · ${pct(stock.change_pct)}`} />
    </div>
  );
}
